import * as yup from 'yup';
import { schema as formOptionsSchema } from './form_options';

export const schema = yup
  .object({
    labelName: yup.string(),
    labelBirthMonth: yup.string(),
    labelBirthYear: yup.string(),
    birthInfoFootnote: yup.string(),
    labelNeutered: yup.string(),
    weightLabel: yup.string(),
    labelActivityLevel: yup.string(),
    noSelectionLabel: yup.string(),
    neutered: yup.array(formOptionsSchema),
    activityLevels: yup.array(formOptionsSchema),
    submitButtonText: yup.string(),
    submitButtonVariant: yup.string(),
  })
  .transform(value =>
    value
      ? {
          labelName: value.label_name,
          labelBirthMonth: value.label_birth_month,
          labelBirthYear: value.label_birth_year,
          birthInfoFootnote: value.birth_info_footnote,
          labelNeutered: value.label_neutered,
          weightLabel: value.weight_label,
          labelActivityLevel: value.label_activity_level,
          noSelectionLabel: value.no_selection_label,
          neutered: value.neutered,
          activityLevels: value.activity_levels,
          submitButtonText: value.submit_button_text,
          submitButtonVariant: value.submit_button_variant,
        }
      : {},
  );
